import { Pipe } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe {
  transform(value: string, args: any) : string {
    let limit = args ? args : 10;

    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pipes/truncate.ts